export default {
  Consultations: 'Consultations',
  consultations: 'Consultation',
  consultation: 'New consultation',
  'consultations.proposed_terms': 'Proposed dates',
  'consultations.calendar': 'Calendar',
  'consultations.edit': 'Edit consultation',
  'consultations.duration_tooltip':
    'Consultation duration in hours, minutes, seconds, days, weeks, months or a year. Examples: 2 hours, 20 minutes, 1 day or combined 1 hour 30 minutes.',
};
